




















import { getQuestProgress } from '@/game/infos/firestoreFiles';
import { WeeklyQuestCode, weeklyQuests } from '@/game/infos/questWeekly';
import { QuestType } from '@/game/infos/unlockModels';
import { ServerTime } from '@/store/api/serverTime';
import userx from '@/store/modules/userx';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { QuestStatus } from './MainQuestPanel.vue';
import QuestComponent from './quests/QuestComponent.vue';

@Component({
  components: {
    QuestComponent,
  },
})
export default class WeeklyQuestPanel extends Vue {
  public allWeeklyQuestCodes = [
    WeeklyQuestCode.LoginSf1,
    WeeklyQuestCode.PlaySf1,
    WeeklyQuestCode.Gacha,
    WeeklyQuestCode.Purchase,
  ];
  public weeklyQuests = weeklyQuests;
  public totalWeeklyQuests = 0;
  public completedWeeklyQuests = 0;
  public time = Date.now();
  public interval: any;

  public get timeLeft() {
    const startDate = 1638028800000;
    const week = 604800000;
    let nextWeek = startDate;
    while (nextWeek < this.time) {
      nextWeek += week;
    }

    const closeTime = nextWeek;
    let tl = closeTime - this.time;
    if (tl < 0) {
      tl = 0;
    }
    const day = Math.floor(tl / (24 * 60 * 60 * 1000));
    tl -= day * 24 * 60 * 60000;
    const hour = Math.floor(tl / (60 * 60 * 1000));
    tl -= hour * 60 * 60000;
    const min = Math.round(tl / 60000);
    // tl -= min * 60000
    return day > 0 ? `${day}d ${hour}h` : `${hour}h ${min}m`;
  }

  public get weeklyQuestStatus(): QuestStatus[] {
    const claimableQuests = userx.claimableQuests;
    const progresses = userx.userDoc.weeklyQuestProgress;
    const quests = weeklyQuests;
    const type = QuestType.Weekly;
    let total = 0;
    let numCompleted = 0;
    const list: QuestStatus[] = this.allWeeklyQuestCodes.map((code) => {
      const claimable = claimableQuests.find(
        (q) => q.type === type && q.code === code,
      )
        ? true
        : false;

      const progressA = getQuestProgress(progresses, code);
      const completed = progressA.currentStep >= quests[code].steps.length;
      if (completed) {
        numCompleted++;
      }
      total++;
      return {
        code,
        claimable,
        type,
        completed,
      };
    });
    this.totalWeeklyQuests = total;
    this.completedWeeklyQuests = numCompleted;
    list.sort((a, b) => {
      if (a.claimable !== b.claimable) {
        if (a.claimable) {
          return -1;
        }
        return 1;
      }
      if (a.completed !== b.completed) {
        if (a.completed) {
          return 1;
        }
        return -1;
      }
      return 0;
    });
    return list;
  }
  public mounted() {
    this.interval = setInterval(() => {
      this.time = ServerTime.time;
    }, 1000);
  }
  public beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
